export default "__VITE_ASSET__LtqUKImb$Ghm41FvZZiKPw__"